<template>
  <div class="login-form">
    <div class="login-form-content">
      <div class="close-button mobile-only">
        <a class="icon-close" @click.prevent="closeModal"> </a>
      </div>
      <form id="email-change-form" class="login-form-login-section">
        <h1 class="heading heading__sm">Change Email</h1>
        <div class="form-group">
          <label for="currentEmail">Enter current Email</label>
          <input
            type="email"
            class="form-control"
            name="currentEmail"
            data-validation="required"
            autocomplete="email"
            v-model="change.email"
          />
        </div>
        <div class="form-group">
          <label for="changeEmail">Enter new Email</label>
          <input
            type="email"
            class="form-control"
            name="changeEmail"
            data-validation="required"
            autocomplete="email"
            v-model="formData.email"
          />
        </div>
        <div class="form-group">
          <label for="confirm_password">Repeat new Email</label>
          <input
            type="email"
            class="form-control"
            id="confirm_email"
            name="confirmEmail"
            data-validation="required confirmation"
            data-validation-confirm="changeEmail"
            data-validation-error-msg="Email adress does not match."
            autocomplete="email"
            v-model="change.confirmEmail"
          />
        </div>
        <div class="row button-row">
          <div class="col-xs-12 col-sm-6">
            <button type="submit" class="btn btn-sm btn-yellow btn-submit">Submit</button>
          </div>
        </div>
      </form>
    </div>
    <div class="login-form-image">
      <div class="close-button">
        <a class="icon-close" @click.prevent="closeModal"> </a>
      </div>
    </div>
  </div>
</template>

<script>
import auth from '../auth'
import config from '../conf'
export default {
  name: 'Login',
  data: function () {
    return {
      change: {
        user_id: '',
        email: '',
        confirmEmail: '',
      },
      user: {
        user_id: '',
        email: '',
      },
      formData: {
        id: '',
        name: '',
        biography: '',
        image: '',
        cover_image: '',
        email: '',
      },
    }
  },
  mounted: function () {
    var self = this
    self.fetchUserDetails()
    $.validate({
      form: '#email-change-form',
      modules: 'security',
      validateHiddenInputs: true,
      scrollToTopOnError: true,
      onSuccess: function ($form) {
        self.changeEmail()
        return false
      },
    })
  },
  methods: {
    changeEmail: function () {
      this.fetchUserDetails()
      if (this.change.email === this.user.email) {
        this.$http
          .put(config.url.listener_users + '/' + this.user.user_id, this.formData, {
            headers: auth.getAuthHeader(),
          })
          .then(
            function (response) {
              if (response.status == 200) {
                this.$notify({
                  title: 'Success!',
                  text: 'Email changed successfully!',
                  type: 'success',
                })
                $('#changeEmailModal').modal('hide')
                this.user.email = this.formData.email
                this.formData.email = ''
                this.change.email = ''
                this.change.confirmEmail = ''
                this.$router.go()
              }
            },
            function (e) {
              $('#changeEmailModal').modal('hide')
              this.formData.email = ''
              this.change.email = ''
              this.change.confirmEmail = ''
              this.$notify({
                title: 'Response Error',
                text: this.getErrorMessage(e),
                type: 'error',
              })
            }
          )
      } else {
        $('#changeEmailModal').modal('hide')
        this.formData.email = ''
        this.change.email = ''
        this.change.confirmEmail = ''
        this.$notify({
          title: 'Error',
          text: 'Current email is wrong',
          type: 'error',
        })
      }
    },
    closeModal: function () {
      $('#changeEmailModal').modal('hide')
    },
    fetchUserDetails: function () {
      var user_id = auth.getLoggedInUserId()
      var self = this
      if (user_id !== null) {
        this.$http
          .get(config.url.listener_users + '/' + user_id, {
            params: {},
            headers: auth.getAuthHeader(),
          })
          .then(
            function (response) {
              self.user.email = response.body.data.email
              self.user.user_id = response.body.data.id
              self.formData.id = response.body.data.id
              self.formData.name = response.body.data.name
              self.formData.biography = response.body.data.biography
              self.formData.image = response.body.data.image
              self.formData.cover_image = response.body.data.cover_image
            },
            function (err) {
              this.router().go()
            }
          )
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ChangeEmail.vue